<template>
  <FamilyDuplicate
    v-if="step === steps.CURRENT_EDITION_DUPLICATE"
    v-model="value"
    :router-return-name="duplicateRouterReturnName"
    @finish="$emit('finish')"
    @duplicateFound="$emit('duplicateFound')"
    @stop="closeAll"
    @next="checkCurrentEditionSimilar"
  />

  <FamilySimilar
    v-else-if="step === steps.CURRENT_EDITION_SIMILAR"
    v-model="similarValue"
    :loading="similarLoading"
    @close="similarValue = false"
    @addNewFamily="stopChecking"
    @forDecision="stopForDecision"
    @overwriteFamily="checkOverwriteOptions"
  />
</template>

<script>
import FamilyDuplicate from '@/components/widgets/addFamily/FamilyDuplicate';
import FamilySimilar from '@/components/widgets/addFamily/FamilySimilar';

import similarityCheckSteps from '@/constants/similarityCheckSteps';

export default {
    name: 'FamilySimilarityCheck',
    components: { FamilyDuplicate, FamilySimilar },
    props: {
        addFamilyCallback: {
            required: false,
            type: Function
        },
        overwriteFamilyEditionCallback: {
            required: false,
            type: Function
        },
        forDecisionCallback: {
            required: false,
            type: Function
        },
        redirectCallback: {
            required: false,
            type: Function
        },
        duplicateRouterReturnName: {
            type: String
        },
        loaderForSimilar: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        value: false,
        similarValue: false,
        steps: similarityCheckSteps,
        step: null,
        similarLoading: false
    }),
    computed: {
        familyData () {
            return this.$store.getters['familyData/getFamilyFormData'];
        },
        similarityParameters () {
            return this.$store.getters['familyData/getSimilarityParameters'];
        }
    },
    watch: {
        loaderForSimilar: {
            handler (val) {
                this.similarLoading = val;
            },
            immediate: true
        }
    },
    methods: {
        init (initState = null) {
            this.step = initState || this.steps.CURRENT_EDITION_DUPLICATE;
            if (this.step === this.steps.CURRENT_EDITION_DUPLICATE) {
                this.value = true;
            } else if (this.step === this.steps.CURRENT_EDITION_SIMILAR) {
                this.checkCurrentEditionSimilar();
            }
        },
        stopChecking () {
            this.addFamilyCallback().then(() => {
                this.closeAll();
            });
        },
        stopForDecision () {
            this.forDecisionCallback();
            this.closeAll();
        },
        closeAll () {
            this.value = false;
            this.similarValue = false;
            this.step = null;
        },
        clearAndGoToSummary () {
            this.closeAll();
            this.$store.commit('familyData/clearFormData');
            this.$store.commit('familyData/setSimilarityParameters', null);
            this.redirectCallback();
        },
        getSimilarFamiliesInCurrentEdition () {
            return this.$store.dispatch('familyData/checkSimilarFamilies');
        },
        checkCurrentEditionSimilar () {
            this.step = this.steps.CURRENT_EDITION_SIMILAR;
            this.getSimilarFamiliesInCurrentEdition().then(() => {
                if (this.$store.getters['familyData/getSimilarFamilies'].length > 0) {
                    this.value = false;
                    this.similarValue = true;
                    this.$emit('finish');
                } else {
                    this.addFamilyCallback().then(() => {
                        this.$emit('finish');
                    });
                }
            });
        },
        checkOverwriteOptions () {
            this.similarLoading = true;
            if (this.similarityParameters.chosenFamily === -1) {
                this.overwriteFamilyEditionCallback()
                    .then(() => {
                        this.clearAndGoToSummary();
                    })
                    .finally(() => {
                        this.similarLoading = false;
                    });
            } else {
                this.clearAndGoToSummary();
                this.similarLoading = false;
            }
        }
    }
};
</script>

<style scoped></style>
